<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">示例图配置</span>
    </div>
    <el-form ref="queryForm" :model="queryForm" label-width="260px">
      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="提交淘宝订单示例图" prop="usertype">
            <el-upload
                action="#"
                list-type="picture-card"
                :auto-upload="false">
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url" alt=""
                >
                <span class="el-upload-list__item-actions">
        <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleDownload(file)"
        >
          <i class="el-icon-download"></i>
        </span>
        <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="手势验证模版号" prop="webTitle">
            <el-input v-model="queryForm.webTitle" placeholder="请输入号码"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
  <el-card>
    <el-form>
      <el-row :gutter="30" style="text-align: center">
        <el-col span="10" style="text-align: right">
          <el-button type="info" icon="el-icon-back">返回</el-button>
        </el-col>
        <el-col span="10" style="text-align: left">
          <el-button type="primary" icon="el-icon-folder">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</div>
</template>

<script>
import MixinCUD from "@/components/MixinCUD";

export default {
  name: "ExampleConfig",
  mixins:[MixinCUD],
  data(){
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      tableData:[],
      queryForm:{
        isneedReview:0,
      },
      checkList: [],
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
      checkList1: []
    }
  },
  methods: {
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    tackReviewChange(val){
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
